// extracted by mini-css-extract-plugin
module.exports = {"root":"DQ7m1","sidebar":"SPoqB","preview":"_2gQMN"};